import React, { useState } from 'react';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import TreeServiceElement from './TreeServiceElement';
import ReactModal from '../../../../../components/ReactModal';
import ManageService from '../../../../../components/ManageService';

const TreeService = (props) => {
  const { service } = props;
  const [serviceModalIsOpen, setServiceModalIsOpen] = useState(false);

  const handleEditService = (e) => {
    e.stopPropagation();
    setServiceModalIsOpen(true);
  };

  return (
    <div style={{ position: 'relative', marginLeft: '-20px', marginRight: '10px' }}>
      <TreeItem
        key={service.id}
        nodeId={service.id}
        label={<TreeServiceElement service={service} />}
        style={{ margin: '8px 0px 8px 8px' }}
        onClick={handleEditService}
      />
      {serviceModalIsOpen && (
        <ReactModal modalIsOpen={serviceModalIsOpen} setIsOpen={setServiceModalIsOpen}>
          <ManageService serviceId={service.id} onClose={() => setServiceModalIsOpen(false)} />
        </ReactModal>
      )}
    </div>
  );
};

export default TreeService;
